import { EventName } from './types';
import { configBase } from '@/config/base';

export const eventIsTracked = (e: EventName) => {
    const events = configBase.tracking.enabled ? window.dataLayer : window.dataLayerDebug;
    return events && events?.findIndex((x) => (x as any).event === e) !== -1;
};

export const createId = () => {
    const u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);

    return [
        u.substr(0, 8),
        u.substr(8, 4),
        '4000-8' + u.substr(13, 3),
        u.substr(16, 12),
    ].join('-');
};
